/**
 * Multi-document template resolution (per ADR-0057).
 *
 * A template is normally one document (`Body`). Some are physically
 * several documents stapled together — the 12 kap. 54 § "Meddelande om
 * ändring av hyresvillkor" is a meddelande page plus a tillägg page, each
 * with its own underskrift. Such a template declares `metadata`-adjacent
 * `documents: [...]` parts; everything else (preview, render, download)
 * goes through `templateDocumentParts()` so the single- and multi-document
 * cases share one code path.
 *
 * The resolver is pure and dependency-free (no React render, no DOM), so
 * both the backend renderer and the SPA preview import it.
 */
/**
 * The ordered documents a template renders to. For a single-document
 * template this is a one-element list synthesised from the top-level
 * `Body` / `Letterhead` / `PageFooter` (key `'document'`, title =
 * `metadata.title`) so callers never branch on `documents` being unset.
 * For a multi-document template each declared part is returned with its
 * `Letterhead` / `PageFooter` defaulted to the template-level subtrees.
 */
export function templateDocumentParts(tmpl) {
    const docs = tmpl.documents;
    if (docs && docs.length > 0) {
        return docs.map((d) => ({
            key: d.key,
            title: d.title,
            Body: d.Body,
            Letterhead: d.Letterhead ?? tmpl.Letterhead,
            PageFooter: d.PageFooter ?? tmpl.PageFooter,
        }));
    }
    return [
        {
            key: 'document',
            title: tmpl.metadata.title,
            Body: tmpl.Body,
            Letterhead: tmpl.Letterhead,
            PageFooter: tmpl.PageFooter,
        },
    ];
}
/** True when the template renders to more than one separate document. */
export function isMultiDocument(tmpl) {
    return (tmpl.documents?.length ?? 0) > 1;
}
//# sourceMappingURL=document-parts.js.map